/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System Sort Icon component.
 */
export const SystemSortIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_14304_19807)'>
        <path d='M7.48978 6.04676L4.10311 2.92676L0.856445 6.04676' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M4.16992 13.0738V3.98047' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M8.50977 9.95312L11.8964 13.0731L15.1431 9.95312' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M11.8232 2.92676V12.0201' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_14304_19807'>
          <rect width={iconSize} height={iconSize} fill={dlsColor('white')} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SystemSortIcon;
